import { createIcon } from '../createIcon.tsx';

export const PaletteIcon = createIcon(
	'PaletteIcon',
	<>
		<circle cx="13.5" cy="6.5" r="1.5" />
		<circle cx="17.5" cy="10.5" r="1.5" />
		<circle cx="8.5" cy="7.5" r="1.5" />
		<circle cx="6.5" cy="12.5" r="1.5" />
		<path d="M12 2a10 10 0 1 0 0 20 2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h1a4 4 0 0 0 4-4 10 10 0 0 0-9-11z" />
	</>,
);
